<template>
	<form class="form normal entry" @submit.prevent="handleSubmit">
		<div class="left-section">
			<div>
				<Logo class="mobile" />

				<Logo :logoOverride="logo2" class="desktop" />
			</div>
		</div>
		<div class="wrap">
			<div class="wrap-wrap">
				<div class="wrap-wrap-wrap">
					<h2 class="form-section-title">Login</h2>

					<p class="dont-have">
						Don't have an account? <router-link to="/create-account" class="strong primary">Sign up here</router-link>
					</p>

					<GoogleSignin 
						@update:showGoogleBtn="showGoogleBtn = $event"
						:login="true" 
						@success="googleSuccess"
						@error="googleError"
					/>

					<div class="or-strip" v-if="showGoogleBtn"><span>Or</span></div>

					<p v-if="showGoogleBtn">Enter your login details below...</p>

					<FormInput
						type="email"
						v-model="email"
						name="email"
						placeholder="Your email address"
						@has-internal-errors="hasInternalErrors"
						v-if="!needs2fa"
						:ignoreEmpty="true"
					/>

					<FormInput
						type="password"
						v-model="password"
						name="password"
						placeholder="Your password"
						@has-internal-errors="hasInternalErrors"
						v-if="!needs2fa"
						:ignoreEmpty="true"
					/>

					<FormInput
						type="text"
						v-model="twoFactor"
						name="twoFactor"
						placeholder="Your Authenticator Code"
						:required="false"
						autocomplete="off"
						v-if="needs2fa"
					/>

					<p class="error" v-if="error !== ''" v-html="error" />

					<input type="submit" value="Login" />

					<router-link to="/forgot-password">Forgot password?</router-link>
				</div>
			</div>

			<Footer :absolute="true" :siteName="siteName" />
		</div>
	</form>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { UserService } from "./../services/user.service";
import FormInput from "./../components/Form/Input.vue";
import Logo from "./../components/Logo.vue";
import Footer from "./../components/Footer.vue";
import general from "./../utils/general";
import GoogleSignin from "./../components/GoogleSignin.vue";
export default {
	name: "Login",
	components: {
		FormInput,
		Logo,
		Footer,
		GoogleSignin
	},
	data() {
		return {
			email: "",
			password: "",
			twoFactor: "",
			privacy: false,
			errors: {},
			errorText: "",
			okToSubmit: true,
			needs2fa: false,
			showGoogleBtn: false
		};
	},
	watch: {
		authenticationError(new1, old1) {
			if (new1 === "needs-2fa" && old1 !== "needs-2fa") {
				this.okToSubmit = true;
				this.needs2fa = true;
			}
		},
	},
	computed: {
		...mapGetters("auth", ["authenticating", "authenticationError", "authenticationErrorCode"]),
		...mapState("general", ["siteName", "logo2"]),

		error() {
			if (this.authenticationError !== "") {
				if (this.authenticationError === "needs-2fa") {
					return this.errorText;
				}

				return this.authenticationError;
			}

			return "";
		},
	},
	created() {
		if (window.location.host.split(":")[0] === "localhost") {
			this.email = "matt" + "@" + "hovr.co";
			this.password = "BlahBlah123";
		}
	},
	mounted() {},
	methods: {
		...mapActions("auth", ["login"]),
		...mapMutations("auth", ['loginSuccess']),
		...mapMutations("general", ["updateLoadingText"]),
		handleSubmit() {
			// Perform a simple validation that email and password have been typed in
			if (this.email != "" && this.password != "" && this.okToSubmit) {
				let u = { email: this.email, password: this.password };

				if (this.needs2fa) {
					if (this.twoFactor.length !== 6) {
						this.errorText = "The code must be 6 numbers long";
						return;
					}

					u.code = this.twoFactor;
				}

				this.login(u);
				this.okToSubmit = true;
			}
		},
		googleSuccess(response) {
			this.updateLoadingText(true);
			this.loginSuccess({ token: UserService.processLoginInfo(response), redirect: true, reload: true });
		},
		googleError(response) {
			console.log('googleError', response);
		},
		hasInternalErrors(a) {
			this.errors[a.name] = a.error;
			this.okToSubmit = true;
			Object.keys(this.errors).forEach(
				function(n) {
					if (this.errors[n].error) {
						this.okToSubmit = false;
					}
				}.bind(this)
			);
		},
	},
};
</script>
